import React, { useState } from 'react';
import { Base_Url,AppointmentBooking } from '../../../config/config';
import { toast } from 'react-toastify';
import { MdDelete } from 'react-icons/md';

export default function AppointmentModal({isopen,onClose,orderId}) {
  const [formData, setFormData] = useState({
    orderId: orderId,
    appointmentDate: '',
    timeSlot: '',
    poNumbers: [''],
    poExpiryDate: '',
    appointmentId: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

   if (!isopen) return null;
  const handlePOChange = (index, value) => {
    const newPONumbers = [...formData.poNumbers];
    newPONumbers[index] = value;
    setFormData(prev => ({
      ...prev,
      poNumbers: newPONumbers
    }));
  };

  const addPOField = () => {
    setFormData(prev => ({
      ...prev,
      poNumbers: [...prev.poNumbers, '']
    }));
  };

  const removePOField = (index) => {
    if (formData.poNumbers.length > 1) {
      const newPONumbers = formData.poNumbers.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        poNumbers: newPONumbers
      }));
    }
  };

  const getTimeSlotValue = (slot) => {
    const timeSlotMap = {
      'morning': '09:00 - 12:00 morning',
      'evening': '14:00 - 18:00 evening',
      'night': '18:00 - 21:00 night'
    };
    return timeSlotMap[slot] || slot;
  };

  const handleSubmit = async () => {

    // setError('');
    
    // // Validation
    // if (orderId || !formData.appointmentDate || !formData.timeSlot) {
    //   setError('Please fill in all required fields');
    //   return;
    // }

    const filteredPONumbers = formData.poNumbers.filter(po => po.trim() !== '');
    if (filteredPONumbers.length === 0) {
      setError('Please enter at least one PO number');
      return;
    }

    setLoading(true);

    try {
      // Get credentials from storage/context (adjust as needed
      const cusId = localStorage.getItem('cus_id') 
      const token = localStorage.getItem('token') 

      const payload = {
        order_id: orderId,
        start_date: formData.appointmentDate,
        end_date: formData.poExpiryDate,
        time_slot: getTimeSlotValue(formData.timeSlot),
        po_number: filteredPONumbers,
        appointment_id : formData.appointmentId  ? formData.appointmentId : ''


      };

      const response = await fetch( Base_Url + AppointmentBooking, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'cus_id': cusId,
          'token': token
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (response.ok || data.status == "success") {
        toast.success(data.message);
        onClose();
        setError('');
      } else {
        setError(data.message || 'Failed to register appointment');
      }
    } catch (err) {
      setError('Network error. Please try again.');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
      {/* Modal Box */}
      <div className="bg-white rounded-custom shadow-custom-light w-[500px] max-h-[90vh] overflow-y-auto p-6 relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        <h2 className="text-2xl font-bold mb-6">Register Appointment</h2>

        {/* Error Message */}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-custom text-sm">
            {error}
          </div>
        )}

        {/* LRN */}
        <div className="mb-4">
          <label className="text-sm font-medium text-gray-700">LRN</label>
          <input
            type="text"
            name="orderId"
            value={orderId}
            disabled
            // onChange={handleInputChange}

            className="w-full mt-1 px-3 py-2 border rounded-custom shadow-custom-light"
            placeholder="Enter LRN/Order ID"
          />
        </div>

        {/* Appointment Row */}
        <div className="grid grid-cols-2 gap-4">
          {/* Appointment Date */}
          <div>
            <label className="text-sm font-medium text-gray-700">Appointment Date</label>
            <input
              type="date"
              name="appointmentDate"
              value={formData.appointmentDate}
              onChange={handleInputChange}
              className="w-full mt-1 px-3 py-2 border rounded-custom shadow-custom-light"
            />
          </div>

          {/* Select Slot */}
          <div>
            <label className="text-sm font-medium text-gray-700">Select Slot</label>
            <select
              name="timeSlot"
              value={formData.timeSlot}
              onChange={handleInputChange}
              className="w-full mt-1 px-3 py-2 border rounded-custom shadow-custom-light"
            >
              <option value="">Select Slot</option>
              <option value="morning">Morning (7 AM - 10 AM)</option>
              <option value="morning">Morning (10 AM - 2 PM)</option>
              <option value="evening">Evening (2 PM - 6 PM)</option>
              <option value="night">Night (6 PM - 9 PM)</option>
            </select>
          </div>
        </div>

        {/* PO Numbers */}
        <div className="mt-4">
          <label className="text-sm font-medium text-gray-700">Enter PO#</label>
          {formData.poNumbers.map((po, index) => (
            <div key={index} className="flex gap-2 mt-2">
              <input
                type="text"
                value={po}
                onChange={(e) => handlePOChange(index, e.target.value)}
                className="flex-1 px-3 py-2 border rounded-custom shadow-custom-light"
                placeholder={`PO Number ${index + 1}`}
              />
              {formData.poNumbers.length > 1 && (
                <button
                  onClick={() => removePOField(index)}
                  className="px-3 py-2 text-red-600 border border-red-200 rounded-custom hover:bg-red-50"
                >
                  <MdDelete/>
                </button>
              )}
            </div>
          ))}
          <button
            onClick={addPOField}
            className="mt-2 text-sm text-customPurple hover:text-purple-700 font-medium"
          >
            + Add Another PO
          </button>
        </div>

        {/* PO Expiry Date */}
        <div className="mt-4">
          <label className="text-sm font-medium text-gray-700">PO Expiry Date</label>
          <input
            type="date"
            name="poExpiryDate"
            value={formData.poExpiryDate}
            onChange={handleInputChange}
            className="w-full mt-1 px-3 py-2 border rounded-custom shadow-custom-light"
          />
        </div>

        {/* Optional Appointment ID */}
        <div className="mt-4">
          <label className="text-sm font-medium text-gray-700">Enter Appointment ID (Optional)</label>
          <input
            type="text"
            name="appointmentId"
            value={formData.appointmentId}
            onChange={handleInputChange}
            className="w-full mt-1 px-3 py-2 border rounded-custom shadow-custom-light"
            placeholder="Optional"
          />
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end mt-6 gap-3">
          <button
          onClick={onclose}
            className="px-4 py-2 border rounded-custom shadow-custom-light text-gray-600 hover:bg-gray-100"
            disabled={loading}
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-customPurple text-white rounded-md hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {loading ? 'Registering...' : 'Register Appointment'}
          </button>
        </div>
      </div>
    </div>
  );
}